// extracted by mini-css-extract-plugin
export default {"container":"BBindEmailMessage-module_container_a607bd2b","verifyBtn":"BBindEmailMessage-module_verifyBtn_a7a85c5e","email":"BBindEmailMessage-module_email_e7d88ea0"};